<div class="modal-backdrop">
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">New Beginnings</h2>
      <button class="close-btn" (click)="onClose()">×</button>
    </div>
    <form [formGroup]="newBeginningsForm" (ngSubmit)="onSubmit()">
      <div class="modal-body">
        <div class="form-field">
          <emerald-input
            [label]="'Name*'"
            [outlined]="true"
            formControlName="employeeName"
            [readOnly]="true"
          ></emerald-input>
        </div>
        <div class="form-field">
          <emerald-input
            [label]="'PS ID*'"
            [outlined]="true"
            formControlName="psid"
            [readOnly]="true"
          ></emerald-input>
        </div>
        <div class="form-field">
          <emerald-input
            [label]="'Email ID*'"
            [outlined]="true"
            formControlName="email"
            [readOnly]="true"
          ></emerald-input>
        </div>
        <div class="form-field">
          <emerald-dropdown
            [label]="'Event Type*'"
            [outlined]="true"
            [isValid]="true"
            [options]="newBeginningsOptions"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
            formControlName="eventType"
          ></emerald-dropdown>
        </div>
        <div class="form-field">
          <textarea
            id="comment"
            class="emerald-textarea"
            rows="3"
            placeholder="Add a Message"
            formControlName="message"
          ></textarea>
        </div>
      </div>
      <div class="modal-actions">
        <emerald-button
          [label]="'Cancel'"
          [type]="'Secondary'"
          (onClick)="onClose()"
        ></emerald-button>
        <emerald-button [label]="'Submit'" [type]="'Primary'"></emerald-button>
      </div>
    </form>
  </div>
</div>
